export const reportStatusMap = {
  pending: { label: 'Pendente', color: 'default' },
  rejected: { label: 'Rejeitada', color: 'blue' },
  accepted: { label: 'Aceito', color: 'red' }
};
